/**
 * Avalara © 2018
 * file: engines/opus_ui/src/search/AvataxSummary.js
 */

import React from 'react';

const AvataxSummary = (data) => {
  return (
    <div className="DeliveryResultsSection">
      <div className="ResultItem">
        <div className="ResultLabel">Avatax Account Id</div>
        <div className="ResultValue">{`${data.id} (${data.status})`}</div>
      </div>
      <div className="ResultItem">
        <div className="ResultLabel">Avatax Account Status</div>
        <div className="ResultValue">
          {data.status ? data.status : 'Not available'}
        </div>
      </div>
    </div>
  );
};

export default AvataxSummary;
